import closeImg from "@images/popups/close.svg";
import {BorderArticle} from "@ui/general/BorderArticle";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const RootPopup = (props) => {
  const {width, children, close, onClick} = props;
  const {isMobile} = useSelector((state) => state.common.settings);

  return (
    <BorderArticle>
      <div
        className={styles.rootPopup}
        style={isMobile ? {maxWidth: "100%"} : {maxWidth: `${width}rem`}}
      >
        {close && (
          <div
            onClick={onClick}
            className={styles.close}
          >
            <img
              src={closeImg}
              alt={"close"}
            />
          </div>
        )}

        {children}
      </div>
    </BorderArticle>
  );
};
